import {NormalizerI} from "./normalizer.i";
import {PhoneNormalizer} from "./phone.normalizer";
import {MoneyNormalizer} from "./money.normalizer";
import {IntegerNormalizer} from "./integer.normalizer";
import {FloatNormalizer} from "./float.normalizer";
import {DateNormalizer} from "./date.normalizer";
import {DocumentNormalizer} from "./document.normalizer";
import {PHONE, MONEY, DATE, INTEGER, FLOAT, DOCUMENT, PERCENTAGE, FIRST_LETTER} from "../../constants";
import {PercentageNormalizer} from "./percentage.normalizer";
import {PERCENTAGE_DECIMAL} from "../../constants/input.types";
import {PercentageDecimalNormalizer} from "./percentage-decimal.normalizer";
import {FirstLetterNormalizer} from "./first-letter-normalizer.service";

/*
 Factory to get instance of normalizer by type
 */
export class NormalizerFactory {

    static getNormalizer(type: string): NormalizerI {
        switch (type) {
            case PHONE: {
                return new PhoneNormalizer();
            }
            case MONEY: {
                return new MoneyNormalizer();
            }
            case DATE: {
                return new DateNormalizer();
            }
            case INTEGER: {
                return new IntegerNormalizer();
            }
            case FLOAT: {
                return new FloatNormalizer();
            }
            case DOCUMENT: {
                return new DocumentNormalizer();
            }
            case PERCENTAGE: {
                return new PercentageNormalizer();
            }
            case PERCENTAGE_DECIMAL: {
                return new PercentageDecimalNormalizer();
            }
            case FIRST_LETTER: {
                return new FirstLetterNormalizer();
            }
            default: {
                return null;
            }
        }
    }

}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/common/components/normalizers/normalizer.factory.ts